module.exports = __webpack_public_path__ + "img/both_icon.9a0a1cb6.svg";